// extracted by mini-css-extract-plugin
module.exports = {"form":"Recovery_form__n5p5e","text":"Recovery_text__0l_XV","action":"Recovery_action__42ms_"};